module.exports = __webpack_public_path__ + "static/media/upon children waering colored stars.cf389130.png";